module.exports = __webpack_public_path__ + "img/icon_map_36_on_011.f0c036ca.png";